import { render, staticRenderFns } from "./WalletType.vue?vue&type=template&id=02997da3&"
import script from "./WalletType.vue?vue&type=script&lang=js&"
export * from "./WalletType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports